<div class="header">
    <h2>Upload <strong>Ispezioni</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li class="active">Upload Ispezioni</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-content">
                <form (ngSubmit)="onSubmit()" #inspectionImportForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="row" style="margin-top: 80px; margin-bottom: 80px;">
                        <div class="col-md-8 col-md-offset-2">
                            <div class="form-group">
                                <label for="contract" class="col-sm-3 control-label">Convenzione *</label>
                                <div class="col-sm-9">
                                    <select class="form-control"
                                            name="contract"
                                            id="contract"
                                            style="width:100%;"
                                            required
                                            [(ngModel)]="contractSelected">
                                        <option [ngValue]="" disabled selected>Seleziona Convenzione...</option>
                                        <option *ngFor="let contract of contracts" [ngValue]="contract.id_contract">{{ contract.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="contract" class="col-sm-3 control-label">File Ispezioni *</label>
                                <div class="col-sm-3">
                                    <span class="input-group-btn">
                                        <label class="btn btn-primary">Seleziona File
                                            <input type="file"
                                                   (change)="onFileSelected($event)"
                                                   required
                                                   hidden>
                                        </label>
                                    </span>
                                </div>
                                <div class="col-sm-6">
                                    <input type="text"
                                           id="inspection-file"
                                           name="inspection-file"
                                           class="form-control-plaintext"
                                           style="font-size: 1.4rem !important;"
                                           readonly
                                           [ngModel]="fileName || 'Nessun file selezionato'">
                                </div>
                            </div>

                            <div class="text-center m-t-20" style="margin-top: 50px !important;">
                                <button type="submit"
                                        class="btn btn-embossed btn-success"
                                        [disabled]="!inspectionImportForm.form.valid || fileName === ''">
                                    <i class="fa fa-upload"></i> Importa Ispezioni</button>
                            </div>

                            <div *ngIf="inspectionImportResult" class="alert alert-success" style="margin-top: 20px;" role="alert">
                                Dati importati correttamente!
                            </div>
                            <div *ngIf="inspectionImportResult === false" class="alert alert-danger" style="margin-top: 20px;">
                                Impossibile caricare il file, verificarne il formato e riprovare.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
